(function($) {
	jQuery.validator.addMethod( 'equalToCaseInsensitive', 
		function( value, element, param ) {
			// copied from jquery.validate.js
			// bind to the blur event of the target in order to revalidate whenever the target field is updated
			// TODO find a way to bind the event just once, avoiding the unbind-rebind overhead
			var target = $(param);
			if ( this.settings.onfocusout ) {
				target.unbind(".validate-equalTo").bind("blur.validate-equalTo", function() {
					$(element).valid();
				});
			}
			return value.toLowerCase() == target.val().toLowerCase();
		},
		function() {
			return pLang__('equaltocaseinsensitivemsg');
		}
	);
}(jQuery));
